<template>
  <div>
    <div class="uppercase text-xs text-gray-500 font-bold">contact</div>
    <div v-if="contactInfo && hasContactInfo">
      <div v-if="contactInfo.name" class="text-sm h-6 flex items-center">
        <i class="icon-user mr-1 text-gray-500"></i>
        <span class="truncate text-gray-700 font-medium">{{ contactInfo.name }}</span>
      </div>
      <div v-if="contactInfo.title" class="text-sm h-6 flex items-center">
        <i class="icon-tag mr-1 text-gray-500"></i>
        <span class="truncate text-gray-700 font-medium">{{ contactInfo.title }}</span>
      </div>
      <a
        v-if="contactInfo.email"
        class="text-sm h-6 flex items-center text-blue-500"
        :href="`mailto:${contactInfo?.email}`"
      >
        <i class="icon-mail mr-1"></i>
        <span class="truncate">{{ contactInfo.email }}</span>
      </a>
      <a
        v-if="contactInfo.phone"
        class="text-sm h-6 flex items-center text-blue-500"
        :href="`tel:${contactInfo?.phone}`"
      >
        <i class="icon-phone mr-1"></i>
        <span class="truncate">{{ contactInfo.phone }}</span>
      </a>
    </div>
    <AddContactInfoButton :mode="hasContactInfo ? 'edit' : 'add'"></AddContactInfoButton>
  </div>
</template>

<script setup lang="ts">
import { IPropertyContactInfo } from '@ncss/models/dist/v3';
import { computed } from 'vue';
import AddContactInfoButton from './AddContactInfoButton.vue';
import { useSelectedProperty } from '@/stores/selected-property.store';

const propertyStore = useSelectedProperty();
const contactInfo = computed(() => propertyStore.property?.contactInfo);

const hasContactInfo = computed(() => {
  return (
    !!contactInfo.value?.email || !!contactInfo.value?.name || !!contactInfo.value?.phone || !!contactInfo.value?.title
  );
});
</script>

<style scoped></style>
